import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  MapPin, 
  Users, 
  Target, 
  FileText, 
  Briefcase, 
  Calendar, 
  Map, 
  BarChart2, 
  Settings,
  ShieldAlert,
  Network,
  Contact,
  Megaphone,
  Database,
  Cpu,
  Box,
  Layers
} from 'lucide-react';
import CompanyLogo from './CompanyLogo';

export default function Sidebar({ user }) {
  const location = useLocation();

  const navItems = [
    { name: 'หน้าหลัก', path: '/', icon: <Home size={20} /> },
    { name: 'Existing Customer', path: '/customers', icon: <Users size={20} /> },
    { name: 'Marketing Lead', path: '/leads', icon: <Megaphone size={20} /> },
    { name: 'Solution Proposal', path: '/simulation', icon: <Layers size={20} /> },
    { name: 'นามบัตรลูกค้า', path: '/business-cards', icon: <Contact size={20} /> },
    { name: 'ปฏิทิน', path: '/calendar', icon: <Calendar size={20} /> },
    { name: 'รายการโปรด', path: '/visits', icon: <Map size={20} /> },
  ];

  // Admin only items
  const adminItems = [
    { name: 'System Architecture', path: '/architecture', icon: <Network size={20} /> },
    { name: 'AGV Designer', path: '/agv-designer', icon: <Box size={20} /> },
    { name: 'ตั้งค่า', path: '/admin', icon: <Settings size={20} /> },
  ];

  if (user?.google_email === 'techin@tmhwst.toyota-industries.com') {
    adminItems.push({ name: 'System Admin', path: '/db-admin', icon: <Database size={20} /> });
  }

  return (
    <aside className="sidebar">
      <div className="sidebar-header" style={{ padding: '1.75rem 1.25rem 1.25rem 1.25rem', display: 'block' }}>
        <CompanyLogo variant="sidebar" />
      </div>
      
      <div className="sidebar-nav">
        {navItems.map((item) => (
          <Link 
            key={item.path} 
            to={item.path} 
            className={`nav-item ${(location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path))) ? 'active' : ''}`}
          >
            {item.icon}
            {item.name}
          </Link>
        ))}

        {(user?.role === 'super_admin') && (
          <>
            <div style={{ margin: '1.5rem 0 0.5rem 1.5rem', fontSize: '0.75rem', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' }}>
              ผู้ดูแลระบบ
            </div>
            {adminItems.map((item) => (
              <Link 
                key={item.path} 
                to={item.path} 
                className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              >
                {item.icon}
                {item.name}
              </Link>
            ))}
          </>
        )}
      </div>

      <div className="sidebar-footer">
        © 2024 Toyota Material Handling
        <br />All rights reserved.
      </div>
    </aside>
  );
}
